import registrationStyles from '../../styles';

export default {
  ...registrationStyles,
};
